module.exports = __webpack_public_path__ + "static/10-aee14effd89888f07ff73b6af1376e7a.jpg";